var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 7L0 0.568H1.092L2.256 4.036C2.32 4.228 2.4 4.456 2.496 4.72C2.592 4.984 2.68 5.244 2.76 5.5C2.848 5.748 2.912 5.952 2.952 6.112H3C3.456 5.608 3.812 5.08 4.068 4.528C4.332 3.968 4.516 3.364 4.62 2.716C4.732 2.06 4.788 1.344 4.788 0.568H5.832C5.832 1.408 5.76 2.192 5.616 2.92C5.472 3.64 5.224 4.336 4.872 5.008C4.528 5.672 4.044 6.336 3.42 7H2.28Z",
    fill: "white",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVega);
export default __webpack_public_path__ + "static/media/vega.eb30ad38bd69f597b43bfd104e871af4.svg";
export { ForwardRef as ReactComponent };